import { createApi } from "@reduxjs/toolkit/query/react";
import { apiBaseQuery } from "../utils/apiBaseQuery";
import { MetaInterface } from "../interfaces/MetaInterface";
import { ApiEnum } from "../enums/ApiEnum";
import { createQueryString } from "../utils/createQueryString";
import { QualificationStandardsInterface } from "../interfaces/QualificationStandardsInterface";

export const qualificationStandardApiSlice = createApi({
    reducerPath: "qualificationStandardApiSlice",
    baseQuery: apiBaseQuery(),
    tagTypes: [],
    endpoints: (builder) => ({
        getQualificationStandards: builder.query<
            {
                data: QualificationStandardsInterface[];
                meta?: MetaInterface;
            },
            {
                page?: number;
                items_per_page?: number;
            }
        >({
            query: (values) => {
                return {
                    url: `${ApiEnum.QUALIFICATION_STANDARD}?${createQueryString(values)}`,
                    method: "GET",
                };
            },
        }),
    }),
});

export default qualificationStandardApiSlice.reducer;

export const { useGetQualificationStandardsQuery } =
    qualificationStandardApiSlice;
